import { Breakpoint } from '../models/breakpoint.enum';

export namespace BreakpointActions {
  export class SetBreakpoint {
    static readonly type = '[View] Set Breakpoint';
    constructor(public breakpoint: Breakpoint) { }
  }
}
